/**
 * The idle warning, the same one the Tab Service portal shows.
 *
 * Same words, same minute on the clock, same two answers: Sign out ends the session now,
 * Continue keeps it. It cannot be dismissed by clicking away or pressing Escape, because
 * ignoring it is not an answer — the clock runs out either way.
 */
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { formatCountdown } from '@/lib/use-session-timeout';

export function SessionTimeoutDialog({
  open,
  secondsLeft,
  extending,
  onExtend,
  onSignOut,
}: {
  open: boolean;
  secondsLeft: number;
  extending: boolean;
  onExtend: () => void;
  onSignOut: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onSignOut(); }}>
      <DialogContent
        title="Session Expiring"
        description="Your session is about to expire in 1 minute due to inactivity. Do you want to extend your session?"
        className="max-w-[440px]"
        dismissible={false}
        footer={
          <>
            <Button variant="outline" size="lg" onClick={onSignOut}>
              Sign out
            </Button>
            <Button size="lg" onClick={onExtend} disabled={extending}>
              {extending ? 'Extending' : 'Continue'}
            </Button>
          </>
        }
      >
        <p className="text-base text-muted-foreground" role="status" aria-live="polite">
          Time remaining <span className="font-medium text-primary tabular-nums">{formatCountdown(secondsLeft)}</span>
        </p>
      </DialogContent>
    </Dialog>
  );
}
